import { render } from "./VimeoPlayer.vue?vue&type=template&id=135ebf50"
import script from "./VimeoPlayer.vue?vue&type=script&lang=js"
export * from "./VimeoPlayer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__